// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import './common/js/font'
import 'lib-flexible'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from '../node_modules/element-ui/lib/locale/lang/en'
Vue.use(ElementUI,{enLocale});
import clipboard from 'clipboard';
//注册到vue原型上
Vue.prototype.clipboard = clipboard;

import './common/style/common.css'
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';
// ...
 
Vue.use(VueFullPage);

import axios from 'axios';
import api   from './api/api_config'
Vue.prototype.$api=api;
Vue.prototype.$http=axios;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js